import { render, staticRenderFns } from "./AtomScrollUp.vue?vue&type=template&id=44561b18&scoped=true&"
import script from "./AtomScrollUp.vue?vue&type=script&lang=js&"
export * from "./AtomScrollUp.vue?vue&type=script&lang=js&"
import style0 from "./AtomScrollUp.vue?vue&type=style&index=0&id=44561b18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44561b18",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
